<template>
  <v-flex class="pa-0 main fill-height" fluid>
    <v-layout>
      <v-flex md12>
        <div>
          <v-layout row wrap justify-end>
            <v-flex md2>
            <NavDrawer/>
            </v-flex>
            <v-flex md9 class="ma-0 pa-0">
              <Header :name="'Analytic Device Configuration'" />
              <v-divider></v-divider>
              <div class="row">
                <v-layout row wrap>
                <v-flex md5 class ="ma-2">
                <v-card class="container pa-2">
                  <DraggableList :items="myList" @update-list="this.updateList1" :title="'LIST OF DEVICES'" />
                </v-card>
                </v-flex>

                <v-flex md5 class ="ma-2">
                <v-card class="container pa-2">
                  <DraggableList :items="myList2" @update-list="this.updateList2" :title="'CONFIGURED DEVICES'" />
                </v-card>
                </v-flex>
                </v-layout>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="proxySave">save</v-btn>
                <v-btn color="error" @click="reset">Reset</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>


<script>
// Default SortableJS
// import draggable from 'vuedraggable'
import NavDrawer from '@/components/common/NavDrawer.vue';
import DraggableList from '@/components/common/DraggableList.vue';
import configService from '@/services/adminConfig.js'
import Header from '@/components/common/ModularComponent/Header.vue';
import { EventBus } from '@/services/event-bus'

import { mapGetters } from 'vuex'

export default {
  components: {
    Header,
    NavDrawer,
    DraggableList
  },
  data() {
      return {
        items: [],
        items2: [],
        newNo: 0
      }
    },
    watch: {
      isUpdating(val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000)
        }
      }
    },
    computed: {
    ...mapGetters(['getSelectedPlantId']),
      myList: {
        get() {
          return this.items;
        },
        set(value) {
          this.items = value;
        }
      },
      myList2: {
        get() {
          return this.items2;
        },
        set(value) {
          this.items2 = value;
        }
      }
    },
     mounted() {
    this.fetchList()
  },
    methods: {
      updateList1(val) {
        this.items2 = val
      },
      updateList2(val) {
        let param = {
          plantId: this.getSelectedPlantId,
          list: []
        }
        val.forEach(item => {
          param['list'].push(item.device_type)
        })
        configService.updatedList(param)
        this.items2 = val
      },
      proxySave() {
        EventBus.$emit('save-template')
      },
      reset() {
        this.fetchList()
      },
      fetchList() {
        configService.fetchConfiguredList(this.getSelectedPlantId).then(res => {
          this.items = res.data.message.availableList
          this.items2 = res.data.message.configuredList
        })
      },
      insertItem: function () {
        var self = this;
        var no = 0;

        if (self.items.concat().length > 0) {
          no = Math.max.apply(null, self.items.concat().map(function (item) {
            return item.no;
          })) + 1;

          self.newNo = self.newNo < no ? no : self.newNo;
        }
        if (self.items2.concat().length > 0) {
          no = Math.max.apply(null, self.items2.concat().map(function (item) {
            return item.no;
          })) + 1;

          self.newNo = self.newNo < no ? no : self.newNo;
        }

        this.items.push({
          no: this.newNo,
          name: 'Garaima' + this.newNo,
          categoryNo: '3'
        });
      },
      deleteItem: function (item, index, group) {
        switch (group) {
          case '':
            var ITEMS = this.items;
            break;
          case '2':
            var ITEMS = this.items2;
            break;
        }

        ITEMS.splice(index, 1);
      }
    }
}

</script>
